<template>
  <div class="hr-radio-field">
    <hr-chips
      :items="state.options"
      v-model:value="state.field.value"
      :errorMessage="state.field.fieldError"
      :disabled="disabled"
      @update:value="updateValue"
    >
      {{ state.field.label }}
      <div v-if="state.field.help?.hint" class="__helper">
        <p v-html="state.field.help?.hint"></p>
      </div>
    </hr-chips>
  </div>
</template>

<script>
import { computed, reactive } from 'vue';
import HrChips from '@/components/hr-chips.vue';
import { validate } from '@/core/validation/validation';
export default {
  name: 'hr-radio-field',
  components: {
    HrChips,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:model-value', 'focus'],
  setup(props, { emit }) {
    const state = reactive({
      field: computed(() => props.modelValue),
      options: [],
    });

    function convertToChips(items) {
      return items.map((item) => {
        return {
          id: item.value,
          description: item.label,
        };
      });
    }

    function updateValue(value) {
      state.field.value = value;
      state.field.valueObj = { unformatted: value, value };
      state.field.fieldError = '';
      emit('focus', state.field);
      validateField();
      emit('update:model-value', state.field);
    }

    function validateField() {
      validate(state.field);
    }

    function initialize() {
      state.options = convertToChips(state.field.children);
    }

    initialize();

    return {
      state,
      convertToChips,
      updateValue,
    };
  },
};
</script>

<style scoped>
.__helper {
  color: var(--co-text-secondary);
  font-weight: normal;
  margin-top: 10px;
}
</style>
